import { solveCdnImgUrlResize } from '@/utils/tools'

export default {
  install: function (Vue, options) {
    Vue.filter('cdnImgResize', (...args) => {
      if (args.length == solveCdnImgUrlResize.length) {
        const [url, w] = args
        return solveCdnImgUrlResize(w, url)
      }
      if (args.length == solveCdnImgUrlResize.length - 1) {
        const [w] = args
        return function (url) {
          return solveCdnImgUrlResize(w, url)
        }
      }
    })
  }
}
